import WestPalmHeroSection from "./components/HeroSection";
import WestPalmStickyNav from "./components/StickyNav";
import WestPalmProcessingTimeSection from "./components/ProcessingTimeSection";
import WestPalmServicesSection from "./components/ServicesSection";
import WestPalmLocalAreaSection from "./components/LocalAreaSection";
import WestPalmTravelTimingSection from "./components/TravelTimingSection";
import WestPalmDestinationsSection from "./components/DestinationsSection";
import WestPalmTestimonialsSection from "./components/TestimonialsSection";
import WestPalmAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import WestPalmComparisonSection from "./components/ComparisonSection";
import WestPalmMistakesSection from "./components/MistakesSection";
import WestPalmHowItWorksSection from "./components/HowItWorksSection";
import WestPalmFAQSection, { faqs } from "./components/FAQSection";
import WestPalmHelpfulResourcesSection, { landmarks as wpbLandmarks } from "./components/HelpfulResourcesSection";
import WestPalmFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const areaServedList = [
  { "@type": "City", name: "West Palm Beach" },
  { "@type": "City", name: "Palm Beach" },
  { "@type": "City", name: "Lake Worth Beach" },
  { "@type": "City", name: "Riviera Beach" },
  { "@type": "City", name: "North Palm Beach" },
  { "@type": "City", name: "Palm Beach Gardens" },
  { "@type": "City", name: "Royal Palm Beach" },
  { "@type": "City", name: "Wellington" },
  { "@type": "AdministrativeArea", name: "Palm Beach County" },
];

const serviceAreaDesc = "Fast Passport Center does not have a physical office in West Palm Beach — we serve this area remotely. Emergency and expedited passport services as fast as 24 hours for West Palm Beach and Palm Beach County travelers. A+ BBB rated.";

const pageTitle = "Emergency Passport West Palm Beach, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in West Palm Beach, FL — as fast as 2–3 business days. A+ BBB rated, registered State Dept. courier serving Palm Beach County, Lake Worth, Royal Palm Beach, and coastal South Florida travelers needing urgent passport help.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function WestPalmPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="West Palm Beach"
        state="Florida"
        stateAbbr="FL"
        route="/cities/west-palm-beach"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="West Palm Beach, Florida"
        geoPosition="26.7153;-80.0534"
        keywords="expedited passport West Palm Beach, emergency passport West Palm Beach FL, same day passport West Palm Beach, fast passport Florida, passport renewal West Palm Beach, Palm Beach County passport courier"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-09"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
        landmarks={wpbLandmarks}
      />
      <WestPalmHeroSection />
      <WestPalmStickyNav />
      <WestPalmLocalAreaSection />
      <WestPalmProcessingTimeSection />
      <WestPalmServicesSection />
      <WestPalmTravelTimingSection />
      <WestPalmDestinationsSection />
      <WestPalmTestimonialsSection />
      <WestPalmAcceptanceFacilitiesSection />
      <WestPalmComparisonSection />
      <WestPalmMistakesSection />
      <WestPalmHowItWorksSection />
      <WestPalmFAQSection />
      <WestPalmHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/west-palm-beach" state="FL" />
      <WestPalmFinalCTA />
    </div>
  );
}